module.exports = {
      id: "ic-drawing-tool-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#ic-drawing-tool-usage",
      toString: function () {
        return this.url;
      }
    }